import {
  type EventDetail,
  type EventInfo,
  type EventInfoDetailApiResponse,
  type EventInfoMain,
  type EventInfoMainApiResponse,
  type EventListApiResponse,
} from '~/features/event-info/types/event-info'
import { END_POINTS, get } from '~/shared/http-client/api'

export const getEventInfoList = async (): Promise<EventInfo[]> => {
  const response: EventListApiResponse = await get(END_POINTS.eventInfo.list)

  return response.data.eventInfo
}

export const getEventInfoMain = async (
  eventId: number,
): Promise<EventInfoMain> => {
  const response: EventInfoMainApiResponse = await get(
    `${END_POINTS.eventInfo.main}/${eventId}`,
  )

  return response.data.info
}

export const getEventInfoDetail = async (
  eventId: number,
): Promise<EventDetail> => {
  const response: EventInfoDetailApiResponse = await get(
    `${END_POINTS.eventInfo.detail}/${eventId}`,
  )

  return response.data.detail
}

export const getEventList = async () => {
  const response: EventListApiResponse = await get(
    `${END_POINTS.eventInfo.list}`,
  )

  return response
}
